// axiosInstance.ts
import axios from 'axios';
import { store } from '../hooks/context/StoreContext';

export const deletarTokenESessao = async () => {
  try {
    const { deletarTokenNoBack } = await import('../service/logout');
    const { deletarSessao } = await import('../service/sessao');

    await deletarTokenNoBack();
    await deletarSessao();
  } catch (e) {
    console.error('Erro ao deletar token ou sessão:', e);
  }

  localStorage.clear();
  sessionStorage.clear();
};

const protocol = process.env.REACT_APP_API_PROTOCOL || 'http';

const axiosInstance = axios.create({
  baseURL: `${protocol}://${process.env.REACT_APP_API_IP}:${process.env.REACT_APP_API_PORT}/api`,
  withCredentials: true,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response => response,
  async (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;

      if (currentPath !== '/login') {
        store.setModal(prev => ({
          ...prev,
          openModalConfirm: true,
          identificadorModalConfirm: 'token-expirado',
          tituloModalConfirm: 'Sessão expirada',
          subtituloModalConfirm: 'Sua sessão expirou ou o token é inválido. Faça login novamente.',
          textoModalConfirm: '',
        }));

      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
